import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { NavLink } from "react-router-dom";
import gql from "graphql-tag";

import { ApolloClient } from 'apollo-client';
import { Query } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

import Select from 'react-select';
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";


const restLink_cloud = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'  
});
const cloud_client = new ApolloClient({
  link: restLink_cloud,
  cache: new InMemoryCache(),
});

const CREATE_COMBO_HAS_VM = gql`
    mutation createOrUpdateComboHasVm($combo_id: Int!, $vm_id: Int!){
      createOrUpdateComboHasVm(id:0,input:{combo_id: $combo_id, vm_id: $vm_id}) {
        id
      }
    }
`;

const DELETE_COMBO_HAS_VM = gql`
    mutation deleteComboHasVm($combo_id: Int!, $vm_id: Int!){
      deleteComboHasVm(combo_id: $combo_id, vm_id: $vm_id) {
        id
      }
    }
`;
const GET_COMBO_HAS_VM = gql`
  query comboHasVm_collection($combo_id: Int!){
    comboHasVm_collection(combo_id :$combo_id) {
      comboHasVms {
        id
        vm {
          value:id
          label:title
        }
      }
    }
  }
`;


const GET_VMS = gql`
query vms_collections($account_id: Int!){
  vms_collections(account_id: $account_id){
    vms{
      value:id
      label:title
    }
  }
}
`;




class ComboHasVm extends Component {

  controllerItens = [];
  urlBack;

  constructor() {
    super();
     this.state = {
       defaultOptions : [],
    }

  }

  
  onChange = (inputValue, action ) => {
    
    // Adicionar
    if(action.action === 'select-option') {
      cloud_client.mutate({
        mutation: CREATE_COMBO_HAS_VM,
        variables: {
          vm_id: action.option.value, combo_id: parseInt(this.props.match.params.combo_id)
        }
      });
    } 
    // Remover
    else if(action.action === 'remove-value') {
      cloud_client.mutate({
        mutation: DELETE_COMBO_HAS_VM,
        variables: {
          vm_id: action.removedValue.value, combo_id: parseInt(this.props.match.params.combo_id)
        }
      });
    }
 
  }

  onInputChange = (inputValue, action ) => {

    console.log("------- CREATE");
    console.log(inputValue);
    
    /*
    cloud_client.mutate({
      mutation: CREATE_COMBO_HAS_VM,
      variables: {
          vm_id: action.removedValue.value, combo_id: parseInt(this.props.match.params.combo_id)
      }
    });
    */
    
  }


  handleSubmit = (event) => {
    event.preventDefault();
    

  }

  render() {
    
    
    return (

      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <a
                  href='javascript:history.go(-1)'
                  className="btn btn-info btn-fill"
                >
                VOLTAR
              </a>

              <Card
                title={"Limitar combo para VMs"}
                category="O combo será aplicado apenas nas VMs selecionadas. Em caso de vazio, será aplicado à todas VMs."
                ctTableFullWidth
                ctTableResponsive
                content={

                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();
                  }}
                  >
                  
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>

                    <Query
                        client={cloud_client}
                        query={GET_VMS}
                        variables={{account_id:this.props.match.params.account_id}}
                      >
                        {({ loading, error, data }) => {

                          if (loading) return <tr><td>Carregando...</td></tr>;
                          if (error) return <tr><td>Erro :(</td></tr>;

                              var vms = data.vms_collections.vms;

                                return (
                        
                                <Query
                                  client={cloud_client}
                                  variables={{combo_id:this.props.match.params.combo_id}}
                                  query={GET_COMBO_HAS_VM}
                                >
                                  {({ loading, error, data }) => {

                                    if (loading) return <tr><td>Carregando...</td></tr>;
                                    if (error) return <tr><td>Erro :(</td></tr>;

                                      var defaultValues = [];
                                      data.comboHasVm_collection.comboHasVms.map((comboHasVm) => {
                                        defaultValues.push(comboHasVm.vm); 
                                      });

                                      return (
                                          <tr>
                                            <td>
                                              <Select
                                                    defaultValue={this.state.defaultValue && this.state.defaultValue ? this.state.defaultValue : defaultValues}
                                                    isMulti
                                                    isSearchable
                                                    name={"values"}
                                                    options={vms}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    //inputValue={inputValue}
                                                    onChange={this.onChange}
                                                    //onInputChange={this.onInputChange}
                                                    isClearable={false}
                                                  />
                                            </td>
                                          </tr>
                                      );
                                  }}
                                </Query>
                                );
                              }}
                            </Query>
                          
                        <tr>
                          <td>
                          <Button bsStyle="info" pullRight fill onClick={() => {window.location.reload()}}>
                            Salvar
                          </Button>
                          </td>
                        </tr>
                    </tbody>
                  </Table>
                  

                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ComboHasVm;
